<template>

    <div class="l-p_content">
        <h1 class="l-p_content__title">
            <router-link to="/" class="l-p_content__logo"></router-link>
        </h1>
        <div class="l-p_content__form">
            <slot></slot>
        </div>
    </div>

</template>


<script>

export default {

    name: 'ThePublicContent'

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.l-p_content {
    padding: 4rem 1rem;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('#{$img}/bg.jpg');

    @include retina {
        background-image: url('#{$img}/bg@2x.jpg');
    }
    @include bp(1600px) {
        min-height: 100vh;
    }
    &__title {
        width: 100%;
        text-align: center;
        margin-bottom: 4rem;
    }
    &__logo {
        display: inline-block;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('#{$img}/logo.svg');
        width: 80%;
        height: 5rem;
        max-width: 200px;
    }
    &__form {
        margin: 0 auto;
        width: 100%;
        max-width: 450px;
        background-color: $c-white;
        padding: 40px;
        border-radius: .25rem;
        box-shadow: 10px 10px 30px $c-shadow;

        @include bp(350px) {
            padding: 20px;
        }
    }
}

</style>
